import React, { memo } from 'react';
import { TableColumn } from '@modules/common/TableColumn';
import { Formatter } from '@core/utils/formatter';

export interface PricingFooterProps {
  title?: string;
  total: number;
  withBorder?: boolean;
}

export const PricingFooter = memo((props: PricingFooterProps) => {
  const { title = '', total, withBorder = '' } = props;

  return (
    <div className={`proposal-table-footer ${withBorder ? 'withBorder' : '' }`}>
      <TableColumn flex={5}>{title}</TableColumn>
      <TableColumn flex={1}>{Formatter.formatCurrency(total, 'USD')}</TableColumn>
    </div>
  );
});
